import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 24px;
  background: #f7faf9;
  font-family: Helvetica, Arial, sans-serif;
`;

const Message = styled.p`
  font-size: 18px;
  color: #666;
  text-align: center;
  font-weight: 400;
`;

const ErrorFallback: React.FC = () => (
  <Wrapper>
    <Message>Sorry, something went wrong.</Message>
  </Wrapper>
);

export default ErrorFallback;
